/** Pure, shared browser/relay privacy contract. No text or trading payloads. */
export interface BrowserSample {
  version: 1;
  session: string;
  sequence: number;
  build: string;
  wallMs: number;
  elapsedMs: number;
  pageAgeMs: number;
  route: 'game' | 'positions' | 'settings' | 'other';
  hidden: boolean;
  heapUsed: number | null;
  heapTotal: number | null;
  heapLimit: number | null;
  elements: number;
  canvases: number;
  canvasPixels: number;
  domTruncated: boolean;
}
const numbers = ['sequence', 'wallMs', 'elapsedMs', 'pageAgeMs', 'elements', 'canvases', 'canvasPixels'] as const;
const heaps = ['heapUsed', 'heapTotal', 'heapLimit'] as const;
const keys = new Set(['version', 'session', 'build', 'route', 'hidden', 'domTruncated', ...numbers, ...heaps]);

export function validBrowserSample(value: unknown): value is BrowserSample {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const v = value as Record<string, unknown>;
  if (Object.keys(v).length !== keys.size || Object.keys(v).some((k) => !keys.has(k))) return false;
  if (v.version !== 1 || typeof v.session !== 'string' || !/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/.test(v.session)) return false;
  if (typeof v.build !== 'string' || !/^(unknown|[a-f0-9]{7,40})$/.test(v.build)) return false;
  if (typeof v.route !== 'string' || !['game', 'positions', 'settings', 'other'].includes(v.route)) return false;
  if (typeof v.hidden !== 'boolean' || typeof v.domTruncated !== 'boolean') return false;
  for (const key of numbers) if (!Number.isSafeInteger(v[key]) || (v[key] as number) < 0) return false;
  for (const key of heaps) if (v[key] !== null && (!Number.isSafeInteger(v[key]) || (v[key] as number) < 0)) return false;
  return (v.sequence as number) <= 60 && (v.sequence as number) >= 1
    && (v.elapsedMs as number) < 30 * 60_000 && (v.elements as number) <= 10_000
    && (v.canvases as number) <= (v.elements as number);
}
